
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/contexts/AuthContext";
import ChatWidget from "@/components/zera/ChatWidget";
import AuthModal from "@/components/zera/AuthModal";
import Index from "./pages/Index";
import Profile from "./pages/Profile";
import AlbanianTravel from "./pages/AlbanianTravel";
import LuxuryTravel from "./pages/LuxuryTravel";
import CorporateTravel from "./pages/CorporateTravel";
import YachtCharters from "./pages/YachtCharters";
import VillaRentals from "./pages/VillaRentals";
import TravelBlog from "./pages/TravelBlog";
import Booking from "./pages/Booking";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider defaultTheme="light">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster />
            <Sonner />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/albanian-travel" element={<AlbanianTravel />} />

              <Route path="/luxury-travel" element={<LuxuryTravel />} />
              <Route path="/corporate-travel" element={<CorporateTravel />} />
              <Route path="/yacht-charters" element={<YachtCharters />} />
              <Route path="/villa-rentals" element={<VillaRentals />} />
              <Route path="/blog" element={<TravelBlog />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <AuthModal />
            <ChatWidget />
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
